import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {RadioBoxItem} from '@/components/ui/radio-box-atoms/RadioBoxAtoms'
import {Root} from '@radix-ui/react-toggle-group'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {useFormContext, Controller} from 'react-hook-form'
import {AddPatientAbsenceFormValidationSchema} from '../../formSchemas'

export const CommunicatedOnTimeField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AddPatientAbsenceFormValidationSchema>()

    return (
        <Controller
            control={control}
            name="communicatedOnTime"
            render={({field}) => (
                <Flexbox direction="column" gap={1.5} fullWidth>
                    <Flexbox gap={1}>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {t('agenda:communication_absence')}
                        </Text>
                        <Text palette="neutral" shade="500" size="textSm" weight="400">
                            {t('commons:optional')}
                        </Text>
                    </Flexbox>

                    <Root
                        type="single"
                        value={field.value ?? undefined}
                        onValueChange={value => {
                            if (value === 'within_48_hours') {
                                field.onChange(value)
                            } else if (value === 'over_48_hours') {
                                field.onChange(value)
                            } else {
                                field.onChange(null)
                            }
                        }}
                        style={{width: '100%'}}
                    >
                        <Grid columns={2} columnGap={4} fullWidth>
                            <RadioBoxItem name="communicatedOnTime" value="within_48_hours">
                                {t('commons:within_48_hours')}
                            </RadioBoxItem>
                            <RadioBoxItem name="communicatedOnTime" value="over_48_hours">
                                {t('commons:over_48_hours')}
                            </RadioBoxItem>
                        </Grid>
                    </Root>
                </Flexbox>
            )}
        />
    )
}
